import { getSessionDuration } from 'application/session_duration'

export function closeModalEvent(data, clickCloseModalLink) {
  window.dataLayer = window.dataLayer || []

  let arraySize = window.dataLayer.length
  let dataLayerIndex = null
  let forLoop = true
  let max = arraySize > 4 ? 4 : arraySize

  for (let i = 1; i < max; i++) {
    if (forLoop && window.dataLayer[arraySize - i].event == "modal_close") {
      dataLayerIndex = arraySize - i
      forLoop = false
    }
  }

  if (dataLayerIndex && window.dataLayer[dataLayerIndex].clickCloseModalLink) { //check if previous modal_close event has clickCloseModalLink param
    window.dataLayer.push({ clickCloseModalLink: null }) //reset clickCloseModalLink to prevent double modal_close push
  } else {
    window.dataLayer.push({
      event: "modal_close",
      clickCloseModalLink: clickCloseModalLink || null,
      session_duration: getSessionDuration(),
      module_name: data.module_name,
      click_text: data.click_text || '',
    });
  }
}
